export default "__VITE_ASSET__CH8zqpGj__"